module.exports = __webpack_public_path__ + "img/88.cb00e26c.jpg";